var React = require('react');

function ExitInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 4C11 3.44772 11.4477 3 12 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H12C11.4477 21 11 20.5523 11 20C11 19.4477 11.4477 19 12 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H12C11.4477 5 11 4.55228 11 4Z","fill":"#CA1905","key":0}),React.createElement("path",{"d":"M6.41421 11L8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289L2.58578 12L7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071C9.09763 16.3166 9.09763 15.6834 8.70711 15.2929L6.41421 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H6.41421Z","fill":"#CA1905","key":1})]);
}

ExitInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ExitInline;

ExitInline.default = ExitInline;
